import type { ShopifyProductVariant } from "@/types/shopify";

export type SelectedOptions = Record<string, string>;

export function getDefaultPurchasableVariant(
  variants: ShopifyProductVariant[]
): ShopifyProductVariant | null {
  return variants.find((variant) => variant.availableForSale) ?? variants[0] ?? null;
}

export function getSelectedOptions(
  variant: ShopifyProductVariant | null | undefined
): SelectedOptions {
  if (!variant) return {};

  return Object.fromEntries(
    variant.selectedOptions.map((option) => [option.name, option.value])
  );
}

export function findVariantForSelection(
  variants: ShopifyProductVariant[],
  selectedOptions: SelectedOptions,
  optionName: string,
  value: string
): ShopifyProductVariant | undefined {
  const nextSelection = { ...selectedOptions, [optionName]: value };

  return variants.find((variant) =>
    variant.selectedOptions.every((option) => nextSelection[option.name] === option.value)
  );
}

export function getDisabledOptionValues(
  variants: ShopifyProductVariant[],
  selectedOptions: SelectedOptions,
  optionName: string,
  values: string[]
): string[] {
  return values.filter((value) => {
    const matchingVariant = findVariantForSelection(
      variants,
      selectedOptions,
      optionName,
      value
    );
    return !matchingVariant?.availableForSale;
  });
}
